export const VALID_STATES = ["NSW", "ACT", "SA", "WA", "QLD", "TAS", "NT", "VIC"];

export function validateEmail(email) {
  // eslint-disable-next-line
  let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function validateAddress(addressLine1) {
  let re = /^([0-9].+?) (.+)$/;
  return re.test(String(addressLine1).toLowerCase());
}
